import axiosInstance from "@/api/axiosConfig";

import type { ResearchFilters } from "./routes";
import type {
  CitationLookup,
  LibraryCoverage,
  LibraryDocument,
  LibraryPassage,
  LibrarySearch,
  ResearchSourceId
} from "./types";

const BASE = "/research/legal";

export const researchApi = {
  search: async (
    source: ResearchSourceId,
    query: string,
    options: { limit?: number; filters?: ResearchFilters } = {}
  ): Promise<LibrarySearch> => {
    const { data } = await axiosInstance.get<LibrarySearch>(BASE, {
      params: {
        source,
        q: query || undefined,
        limit: options.limit ?? 10,
        ...options.filters
      }
    });
    return data;
  },
  document: async (id: string): Promise<LibraryDocument> => {
    const { data } = await axiosInstance.get<LibraryDocument>(
      `${BASE}/documents/${encodeURIComponent(id)}`
    );
    return data;
  },
  passages: async (
    query: string,
    documentId: string,
    limit = 6
  ): Promise<LibraryPassage[]> => {
    const { data } = await axiosInstance.get<{ passages: LibraryPassage[] }>(
      `${BASE}/passages`,
      { params: { q: query, document_id: documentId, limit } }
    );
    return data.passages;
  },
  citation: async (query: string): Promise<CitationLookup> => {
    const { data } = await axiosInstance.get<CitationLookup>(
      `${BASE}/citation`,
      { params: { q: query } }
    );
    return data;
  },
  coverage: async (): Promise<LibraryCoverage> => {
    const { data } = await axiosInstance.get<LibraryCoverage>(
      `${BASE}/coverage`
    );
    return data;
  }
};
